import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { YesNoPrompt } from '@huge-monorepo/shared/interfaces';
@Component({
  selector: 'app-yes-no-modal',
  templateUrl: './yes-no-modal.component.html',
  styleUrls: ['./yes-no-modal.component.scss'],
})
export class YesNoModalComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<YesNoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: YesNoPrompt) { }

  ngOnInit() { }

  closeDialog(val: boolean) {
    this.dialogRef.close(val);
  }
}
